export const teamPaths = {
    list: () => 'admin/teams',
    detail: (id) => `admin/teams/${id}`,
    members: (id) => `admin/teams/${id}/members`,
    projectTeams: () => 'admin/project-teams',
};

// Reference only: the real pause/enable goes through this contract route,
// which the draft deliberately never calls (see docs/decisions/003).
export const AGENT_ORDERS_PATH = (positionId) => `admin/agents/${positionId}/orders`;
